import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { QueryBuilder } from "react-querybuilder";
import "react-querybuilder/dist/query-builder.css";
import { toast } from "react-toastify";
import {
  ADD_FILTER,
  GET_TAG_TO_FILTER,
  UPDATE_FILTER,
} from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import "../HomeHeader.css";

const FilterModal = (props) => {
  const { editData } = props;

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "58%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  const [query, setQuery] = useState();
  const [name, setName] = useState("");
  const [error, seterror] = useState(false);
  const [errorfortags, seterrorfortags] = useState(false);
  const [id, setId] = useState("");
  const [filterfield, setfilterfield] = useState();
  const [parsedFilters, setParsedFilters] = useState();
  const [customFilterState, setcustomFilterState] = useState(false);
  const [allfilterfield, setallfilterfield] = useState();
  const [updateTags, setUpdateTags] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`${GET_TAG_TO_FILTER}`, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });
        let filtertags = response?.data.filter_tags;
        let allfiltertags = response?.data.all_tags;
        setfilterfield(filtertags);
        setallfilterfield(allfiltertags);
      } catch (error) {}
    };

    fetchData();
  }, [updateTags]);
  useEffect(() => {
    if (Object.keys(editData).length) {
      setName(editData.name);
      setParsedFilters(JSON.parse(editData.filters));
      setId(editData.id);
    }
  }, [editData]);
  useEffect(() => {
    if (parsedFilters) {
      setQuery(parsedFilters);
    }
  }, [parsedFilters]);

  let fields =
    filterfield &&
    filterfield.map((option) => ({
      name: option,
      label: option,
    }));
  let allfields =
    allfilterfield &&
    allfilterfield.map((option) => ({
      name: option,
      label: option,
    }));

  const handleFilter = async (e) => {
    if (!name || !query.rules.length) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const SendData = async () => {
      let filterobj = { name: name, filters: JSON.stringify(query) };
      try {
        const response = await axiosInstance.post(`${ADD_FILTER}`, filterobj, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });

        if (response.data.success && response.data.success == true) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setName("");
          setQuery();
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  const handleEditSubmit = async (e) => {
    if (!name || !query.rules.length) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }
    const SendData = async () => {
      let filterobj = { id: id, name: name, filters: JSON.stringify(query) };
      try {
        const response = await axiosInstance.put(
          `${UPDATE_FILTER}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );

        if (response.data.success && response.data.success == true) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setName("");
          setQuery();
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  return (
    <div>
      <Modal
        className="rounded d-flex justify-content-center align-items-center"
        open={props.ModalState}
        onClose={props.handleClose}
      >
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between ">
            <div className="h5 font-weight-bold  mt-2">Filter</div>
            <div className=" ">
              <IconButton
                className="text-light"
                onClick={props.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div className="my-4 rounded">
            <div className="sort_search_header_field mb-1">Name*</div>

            <div>
              <input
                className="text-input-modal"
                required
                id="name"
                placeholder="Name"
                label="Name"
                onChange={(e) => setName(e.target.value.trimStart())}
                value={name}
              />
            </div>
            {!name && error && (
              <span className="errorStyles">NAME Required</span>
            )}
          </div>
          <div
            className="mt-3 transparent-color border border-warning rounded"
            style={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            <div>
              <QueryBuilder
                query={query}
                controlClassnames={{ queryBuilder: "queryBuilder-branches" }}
                fields={fields}
                onQueryChange={(q) => setQuery(q)}
              />
            </div>
            {query && query.rules.length === 0 && error && (
              <span className="errorStyles">QUERY Required</span>
            )}
          </div>
          {!customFilterState && (
            <div className="d-flex justify-content-between">
              <div>
                {" "}
                <button
                  className="btn-class"
                  onClick={
                    Object.keys(editData).length
                      ? handleEditSubmit
                      : handleFilter
                  }
                >
                  SUBMIT
                </button>
              </div>

              <div>
                <button
                  className="btn-class"
                  onClick={() => {
                    props.handleCustomFilter(allfields);
                  }}
                >
                  Add Custom Filter
                </button>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
};
export default FilterModal;
